import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectMeForUpdate } from '@/store/me';
import moment from 'moment-timezone';
import { TIME_ZONE_CONSTANTS } from '@/utils/timeZoneConstants';

export const useTzOptions = () => {
  const { time_zones } = useSelector(selectMeForUpdate) || {};

  const tzOptions = (time_zones) => {
    const timezoneData =
      Object.keys(time_zones || {}).length > 0
        ? time_zones
        : TIME_ZONE_CONSTANTS;

    return Object.entries(timezoneData || {}).map(([key]) => {
      const { fullName, shortName, abbreviation } =
        TIME_ZONE_CONSTANTS[key] || {};
      // Calculate current offset using moment-timezone
      const offsetInMinutes = moment().tz(key).utcOffset();
      const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
      const minutes = Math.abs(offsetInMinutes) % 60;
      const sign = offsetInMinutes < 0 ? '-' : '+';
      const liveOffset = `GMT${sign}${String(hours).padStart(2, '0')}:${String(
        minutes
      ).padStart(2, '0')}`;

      return {
        label: `${fullName} (${liveOffset}) - ${shortName}`,
        value: key,
        offset: liveOffset,
        abbreviation: abbreviation || '',
        fullName: fullName || '',
        shortName: shortName || '',
      };
    });
  };

  const timeZoneOptions = useMemo(() => {
    return tzOptions(time_zones);
  }, [time_zones]);

  const customFilterOption = useCallback((option, inputValue) => {
    const searchTerm = inputValue.toLowerCase();
    const abbreviation = option?.data?.abbreviation?.toLowerCase() || '';
    const fullName = option?.data?.fullName?.toLowerCase() || '';
    const shortName = option?.data?.shortName?.toLowerCase() || '';
    const label = option?.data?.label?.toLowerCase() || '';

    return (
      abbreviation.includes(searchTerm) ||
      fullName.includes(searchTerm) ||
      shortName.includes(searchTerm) ||
      label.includes(searchTerm)
    );
  }, []);

  return { timeZoneOptions, customFilterOption };
};
